import React, { Component } from 'react';

export default class NotFound extends Component {
  render = () => (
    <div>
      Not Found
    </div>
  )
}
